import api from './api';

const empresaService = {
  // Obtener todas las empresas
  getEmpresas: async () => {
    try {
      const response = await api.get('/api/companies');
      return response.data;
    } catch (error) {
      console.error('Error al obtener empresas:', error);
      throw error;
    }
  },

  // Obtener una empresa por ID
  getEmpresaById: async (id) => {
    try {
      const response = await api.get(`/api/companies/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener empresa con ID ${id}:`, error);
      throw error;
    }
  },

  // Crear una nueva empresa
  createEmpresa: async (empresaData) => {
    try {
      const response = await api.post('/api/companies', empresaData);
      return response.data;
    } catch (error) {
      console.error('Error al crear empresa:', error);
      throw error;
    }
  },

  // Actualizar una empresa existente
  updateEmpresa: async (id, empresaData) => {
    try {
      const response = await api.put(`/api/companies/${id}`, empresaData);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar empresa con ID ${id}:`, error);
      throw error;
    }
  },

  // Eliminar una empresa
  deleteEmpresa: async (id) => {
    try {
      const response = await api.delete(`/api/companies/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al eliminar empresa con ID ${id}:`, error);
      throw error;
    }
  },

  // Cambiar el estado de una empresa
  changeCompanyState: async (id, newState) => {
    try {
      const response = await api.patch(`/api/companies/${id}/state`, { newState });
      return response.data;
    } catch (error) {
      console.error(`Error al cambiar el estado de la empresa con ID ${id}:`, error);
      throw error;
    }
  }
};

export default empresaService;
